/* eslint-disable camelcase */
import { capitalize, first } from 'lodash';
import TagManager from 'react-gtm-module';
import { OrderTypes } from '../../../../constants/OrderTypes';
import { PayloadWithProductsListAndSelectedProduct } from '../../../../entities/product/types';
import {
  createListName,
  DEFAULT_MOB_USER_PROPERTIES,
  DEFAULT_MOB_USER_PROTERTIES_NEW,
  generateCheckoutEventName,
  getBasketValue,
  getDeviceOverviewSelectedTariff,
  getTariffPackageTypeFromName,
  isDevice,
  mapDeviceListItemToEcommerceGa4Item,
  mapDeviceOverviewToEcommerceGa4Item,
  parseBasketForAnalytics,
  parseInsuranceItemForAnalytics,
} from '../../../../utilites/ga4utils';
import { AppState } from '../../rootReducers';
import { PushDeviceListToAnalyticsActionPayload } from '../types';
import { GA4Item, GA4EcommerceMobEvent, GA4EcommerceItem, GA4MobEventType } from './types';

const RSD = 'RSD';

abstract class IAnalyticsMiddlewareGA4MobProxy {

  public static viewDeviceList: (state: AppState, { products }: PushDeviceListToAnalyticsActionPayload) => void;
  public static selectDevice: (state: AppState, { product }: PayloadWithProductsListAndSelectedProduct) => void;
  public static viewDevice: (state: AppState) => void;
  public static addToCart: (state: AppState) => void;
  public static viewCart: (state: AppState) => void;
  public static viewCampaignCart: (state: AppState) => void;
  public static campaignP2pDjStep: (state: AppState, eventName: string) => void;
  public static campaignP2pDjStep2: (state: AppState) => void;
  public static campaignP2pDjStep3: (state: AppState) => void;
  public static campaignP2pDjPurchase: (state: AppState) => void;
  public static cancelOrder: (state: AppState) => void;
  public static orderCanceled: (state: AppState) => void;
  public static selectInsurance: (state: AppState, items: GA4Item[]) => void;
  public static checkoutStep: (state: AppState, orderType: string, stepName: string, previousSteps: any[]) => void;
  public static choosePackage: (state: AppState, data: Partial<GA4EcommerceItem>) => void;
  public static submitCampaignChoice: (
    state: AppState,
    payload: { data: Partial<GA4EcommerceItem>; eventName: GA4MobEventType }
  ) => void;
  public static campaignConfirmation: (state: AppState, eventName: GA4MobEventType) => void;
  public static acessoryGoToCheckout: (state: AppState) => void;

}

// TODO: unkown variables   payment_method    Yettel | Yettel Bank

// TODO: unkown variables   user_actualTariffName: '',
// TODO: unkown variables   user_carrierType: '',
// TODO: unkown variables   user_customerType: '',
// TODO: unkown variables   user_propertyType: 'webshop',
// TODO: unkown variables   user_planType: '',
// TODO: unkown variables   user_isp: '',

export default class AnalyticsMiddlewareGA4MobProxy extends IAnalyticsMiddlewareGA4MobProxy {

  public static viewDeviceList = (state: AppState, { products }: PushDeviceListToAnalyticsActionPayload) => {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const searchParams = state.searchParams.productList;
    const formattedItems = products.slice(0, 20).map(mapDeviceListItemToEcommerceGa4Item);
    const itemListName = createListName(searchParams, products[0]);

    const urlSearchParams = Array.from(new URLSearchParams(window.location.search))
      .map((subarray) => `${subarray[0]}: ${subarray[1]}`)
      .join(' | ');

    formattedItems.map((item) => {
      item.item_list_name = itemListName;
      return item;
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_view_item_list',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          active_filters: urlSearchParams,
          items: formattedItems,
        },
      } as GA4EcommerceMobEvent,
    });
  };

  public static selectDevice(state: AppState, { product }: PayloadWithProductsListAndSelectedProduct) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const searchParams = state.searchParams.productList;
    const selectedItem = mapDeviceListItemToEcommerceGa4Item(product);
    selectedItem.item_list_name = createListName(searchParams, product);

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_select_item',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: [selectedItem],
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static viewDevice(state: AppState) {
    const searchParams = new URLSearchParams(window.location.search);
    const cosmosInstallments = searchParams.get('cosmosInstallments');
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const {
      productData,
      product: { item },
    } = state.productData;

    const device = mapDeviceOverviewToEcommerceGa4Item(item, productData.tariff);
    const tariffPackageObject = getDeviceOverviewSelectedTariff(item, productData.tariff);

    const items: GA4EcommerceItem[] = [];

    if (tariffPackageObject) {
      device.package_details = tariffPackageObject.package_details;
      items.push(tariffPackageObject);
    }

    items.push(device);

    let value = Number(
      (item.displayCreditTotalMonthlyCosts || item.displayPriceTotalMonthlyCosts)?.toString().replace('.', '')
    );

    if (cosmosInstallments) {
      value = Number(cosmosInstallments) * value;
    }

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_view_item',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items,
          currency: RSD,
          value,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static addToCart(state: AppState) {
    const searchParams = new URLSearchParams(window.location.search);
    const cosmosInstallments = searchParams.get('cosmosInstallments');
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const {
      productData,
      product: { item },
    } = state.productData;

    const device = mapDeviceOverviewToEcommerceGa4Item(item, productData.tariff);
    const tariffPackageObject = getDeviceOverviewSelectedTariff(item, productData.tariff);

    const items: GA4EcommerceItem[] = [];

    if (tariffPackageObject) {
      device.package_details = tariffPackageObject.package_details;
      items.push(tariffPackageObject);
    }

    items.push(device);

    let value = Number(
      (item.displayCreditTotalMonthlyCosts || item.displayPriceTotalMonthlyCosts)?.toString().replace('.', '')
    );

    if (cosmosInstallments) {
      value = Number(cosmosInstallments) * value;
    }

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_add_to_cart',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items,
          currency: RSD,
          value,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static viewCart(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const { order } = state.manhattanOrder;
    const basketItems = order.basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);
    const isBundle = [OrderTypes.BUNDLE_FTTH, OrderTypes.BUNDLE_OTT, OrderTypes.BUNDLE_POST_OTT].includes(order.type);
    const isCampaign = order.basket.campaignType;

    if (isBundle) {
      parsedBasketItems.map((item) => {
        item!.bundle_vs_standalone = 'Bundle';
        return item;
      });
    }

    if (isCampaign) {
      parsedBasketItems.map((item) => {
        item!.user_type = order.basket.campaignType;
        return item;
      });
    }

    const extraInfo = {
      cart_order_id: order.order.referenceId,
      currency: RSD,
      value: getBasketValue(basketItems),
    };

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_view_cart',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: parsedBasketItems,
          ...extraInfo,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static viewCampaignCart(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const overview = state.campaign.overview;

    const item = {
      binding_period: overview.contractDuration,
      bundle_vs_standalone: 'Standalone',
      item_brand: 'Yettel',
      item_category: 'Packages',
      item_category2: 'Pre2Postpaid',
      item_category3: getTariffPackageTypeFromName(overview.tp?.name),
      item_category4: 'Postpaid',
      item_category5: 'Consumer',
      item_id: overview.offerId,
      item_list_id: 'Prelazak sa pripejda na postpejd',
      item_list_name: 'Prelazak sa pripejda na postpejd',
      item_name: overview.tp?.name,
      monthly_installment: overview.tp?.cosmosSubscription,
      package_details: '',
      price: overview.contractDuration * overview.tp?.subscription,
      user_type: 'pre2Post'
    };

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_view_cart',
        ecommerce: {
          currency: RSD,
          user_id: gtmUserId,
          ...DEFAULT_MOB_USER_PROPERTIES,
          items: [item],
        },
      },
    });
  }

  public static campaignP2pDjStep(state: AppState, eventName: string) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const { order } = state.manhattanOrder;
    const basketItems = order.basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);

    parsedBasketItems.map((item) => {
      item!.user_type = order.basket.campaignType;

      item.item_category2 = "Pre2Postpaid";
      item.item_category3 = item.item_name ?? getTariffPackageTypeFromName(item.item_name);
      item.item_list_id = "Prelazak sa pripejda na postpejd";
      item.item_list_name = "Prelazak sa pripejda na postpejd";
      item.user_type = "pre2Post";

      return item;
    });

    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ecommerce: {
          cart_order_id: order.order.referenceId,
          currency: RSD,
          user_id: gtmUserId,
          ...DEFAULT_MOB_USER_PROPERTIES,
          items: parsedBasketItems
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static campaignP2pDjPurchase(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    const { order } = state.manhattanOrder;
    const basketItems = order.basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);

    parsedBasketItems.map((item) => {
      item!.user_type = order.basket.campaignType;

      item.item_category2 = "Pre2Postpaid";
      item.item_category3 = item.item_name ?? getTariffPackageTypeFromName(item.item_name);
      item.item_list_id = "Prelazak sa pripejda na postpejd";
      item.item_list_name = "Prelazak sa pripejda na postpejd";
      item.user_type = "pre2Post";

      return item;
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_checkout_6_pregled_porudzbine',
        ecommerce: {
          cart_order_id: order.order.referenceId,
          currency: RSD,
          user_id: gtmUserId,
          ...DEFAULT_MOB_USER_PROPERTIES,
          items: parsedBasketItems
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static cancelOrder(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;

    const {
      data: { basket },
    } = state.manhattanTransaction;
    const basketItems = basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_cancel_order',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: parsedBasketItems,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static selectInsurance(state: AppState, items: GA4Item[]) {
    const gtmUserId = state.session.gtmData?.gtmUserId;

    const insuranceItem = first(items.filter((item) => item.item_category === 'Insurance'));

    if (insuranceItem) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'mob_device_accessories_insurance',
          ecommerce: {
            ...DEFAULT_MOB_USER_PROPERTIES,
            user_id: gtmUserId,
            items: [parseInsuranceItemForAnalytics(insuranceItem)],
            currency: RSD,
          },
        } as GA4EcommerceMobEvent,
      });
    }
  }

  public static checkoutStep(state: AppState, orderType: string, stepName: string, previousSteps: any[]) {
    const orderTypesOfInterest = [OrderTypes.TELCO, OrderTypes.COMPLEX, OrderTypes.ACCESSORY];
    if (!orderTypesOfInterest.includes(orderType)) {
      return;
    }

    const gtmUserId = state.session.gtmData.gtmUserId;
    const { order } = state.manhattanOrder;
    const basketItems = order.basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);
    const isBundle = [OrderTypes.BUNDLE_FTTH, OrderTypes.BUNDLE_OTT, OrderTypes.BUNDLE_POST_OTT].includes(order.type);
    const isCampaign = order.basket.campaignType;
    const greenVoucherApplied =
      basketItems
        .filter((item: any) => isDevice(item))
        .filter((device: any) => {
          const greenVoucher = device.price?.discounts?.find((discount: any) => discount.type === 'greenVoucher');
          return Boolean(greenVoucher);
        }).length > 0;

    if (isBundle) {
      parsedBasketItems.map((item) => {
        item!.bundle_vs_standalone = 'Bundle';
        return item;
      });
    }

    if (isCampaign) {
      parsedBasketItems.map((item) => {
        item!.user_type = order.basket.campaignType;
        return item;
      });
    }

    if (greenVoucherApplied) {
      parsedBasketItems.map((item) => {
        if (item.hasOwnProperty('device_recycle')) {
          item.device_recycle = 'Yes';
        }

        return item;
      });
    }

    const extraInfo = {
      cart_order_id: order.order.referenceId,
      currency: RSD,
      value: getBasketValue(basketItems),
    };

    const chosenNumberStep = first(previousSteps.filter((stp) => stp.step === 'chooseNumberState'));
    const choosePaymentMethodStep = first(
      previousSteps.filter(
        (stp) => stp.step === 'customerCheckPaymentOptionsState' || stp.step === 'paymentOptionState'
      )
    );
    const chooseDeliveryMethodStep = first(previousSteps.filter((stp) => stp.step === 'deliveryInfoState'));

    if (chosenNumberStep) {
      const stepData = chosenNumberStep.data;
      const numberOwnership = stepData.existingCustomer === 'newCustomer' ? 'New' : 'Existing';
      const numberType = capitalize(stepData.msisdnCategory);

      parsedBasketItems.map((item) => {
        if (item.hasOwnProperty('number_ownership') && item.hasOwnProperty('number_type')) {
          item.number_ownership = numberOwnership;
          item.number_type = numberType;
        }

        return item;
      });
    }

    if (choosePaymentMethodStep) {
      //@ts-ignore
      extraInfo.payment_type = choosePaymentMethodStep.data?.selectedPaymentOption;
    }

    if (chooseDeliveryMethodStep) {
      const deliveryType = chooseDeliveryMethodStep.data?.deliveryDetails?.type === 'store' ? 'store' : 'address';
      //@ts-ignore
      extraInfo.delivery_type = deliveryType;
    }

    TagManager.dataLayer({
      dataLayer: {
        event: generateCheckoutEventName(orderType, stepName),
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: parsedBasketItems,
          ...extraInfo,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static choosePackage(state: AppState, data: Partial<GA4EcommerceItem>) {
    const gtmUserId = state.session.gtmData?.gtmUserId;

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_choose_package',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: [data],
          currency: RSD,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static submitCampaignChoice(
    state: AppState,
    payload: { data: Partial<GA4EcommerceItem>; eventName: GA4MobEventType }
  ) {
    const gtmUserId = state.session.gtmData?.gtmUserId;
    // Back up the user id for the confirmation screen.
    sessionStorage.setItem('gtmUserId', gtmUserId);

    TagManager.dataLayer({
      dataLayer: {
        event: payload.eventName,
        user_id: gtmUserId,
        user_properties: {
          ...DEFAULT_MOB_USER_PROTERTIES_NEW,
        },
        ecommerce: {
          currency: RSD,
          items: [payload.data],
        },
      },
    });
  }

  public static campaignConfirmation(state: AppState, eventName: GA4MobEventType) {
    const gtmUserId = state.session.gtmData?.gtmUserId || sessionStorage.getItem('gtmUserId');

    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        user_id: gtmUserId || '',
        user_properties: {
          ...DEFAULT_MOB_USER_PROTERTIES_NEW,
        },
        ecommerce: {
          currency: RSD,
          items: [],
        },
      },
    });
  }

  public static orderCanceled(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;

    const {
      data: { basket },
    } = state.manhattanTransaction;
    const basketItems = basket.items[0].items;

    const parsedBasketItems = parseBasketForAnalytics(basketItems);

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_order_canceled',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: parsedBasketItems,
          currency: RSD,
        },
      } as GA4EcommerceMobEvent,
    });
  }

  public static acessoryGoToCheckout(state: AppState) {
    const gtmUserId = state.session.gtmData?.gtmUserId;

    const {
      productData,
      product: { item },
    } = state.productData;

    const device = mapDeviceOverviewToEcommerceGa4Item(item, productData.tariff);

    TagManager.dataLayer({
      dataLayer: {
        event: 'mob_device_accessories_insurance',
        ecommerce: {
          ...DEFAULT_MOB_USER_PROPERTIES,
          user_id: gtmUserId,
          items: [device],
          currency: RSD,
        },
      } as GA4EcommerceMobEvent,
    });
  }

}
